import evaluationApiClient from "common/Adapters/EvaluationApiClient/evaluationApiClient";

export function fetchCalculation(lang, data, onError, companyAccess = false) {
  return evaluationApiClient.getCalculations(lang, data, onError, companyAccess);
}
